export const TenantNameBlocklist = ['www', 'app', 'prod', 'demo', 'test', 'dev', 'local', 'localhost'];
